import ModalTutorial from 'components/ui/ModalTutorial';
import { useAuth } from 'context/AuthContext';
import { useModal } from 'context/ModalContext/Modal.context';
import { createContext, ReactNode, useContext, useEffect, useRef, useState } from 'react';
import { getTutorial } from 'services/tutorial.service';
import { Tutorial } from 'types/tutorial';
import { getStorageItem } from 'utils/storage';

import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { Step } from 'types/tutorial';
import { A11y, Navigation, Pagination, Scrollbar } from 'swiper/modules';

interface AppContextInterface {
    tutorial?: Tutorial;
    setTutorial: (val?: any) => void;
}

interface AppProviderProps {
    children: ReactNode;
}

const AppContext = createContext({} as AppContextInterface);

function AppContextData(): AppContextInterface {
    const [tutorial, setTutorial] = useState<Tutorial>();
    const { user } = useAuth();
    const { showModal } = useModal();
    const [swiperInstance, setSwiperInstance] = useState<any>(null);
    const swiperRef = useRef();

    // useEffect(() => {
    //     const viewTutorial = getStorageItem('check_tutorial');

    //     if (!!user) {
    //         (async () => {
    //             const tutorial = await getTutorial('6787e5fde510835c7932dba3');
    //             console.log('tutorial', tutorial);
    //             setTutorial(tutorial);
    //             if (!viewTutorial) {
    //                 showModal('tutorial', <ModalTutorial />, 'tutorial');
    //             }
    //         })();
    //     }
    //     // console.log(tutorial);
    // }, [user]);

    return {
        tutorial,
        setTutorial
    };
}

const AppContextProvider = ({ children }: AppProviderProps) => {
    const contextData: AppContextInterface = AppContextData();

    return <AppContext.Provider value={contextData}>{children}</AppContext.Provider>;
};

const useAppContext = (): AppContextInterface => {
    const context = useContext(AppContext);

    if (typeof context === 'undefined') {
        throw new Error('Error on appContext');
    }

    return context;
};

export { AppContextProvider, useAppContext };
